@if (warning) {
  <div class="signon-warning-container">
    <div class="signon-warning-row">
      <div class="warning-icon">
        <app-warning-icon [messageType]="warning.messageType"></app-warning-icon>
      </div>
      <div class="warning-content">
        <div class="warning-time">{{warning?.measuredAt | amTimeAgo}}</div>
        <div class="warning-text">{{'Vehicle not signed in' | translate}}</div>
      </div>
      <div class="warning-action">
        <button type="button" class="signon-button" [disabled]="state !== SignOnWarningState.Initial && state !== SignOnWarningState.Error"
          (click)="signOn()">
          @if (state === SignOnWarningState.Loading) {
            <mat-spinner diameter="16">
            </mat-spinner>
          }
          <span>{{'Sign On' | translate}}</span>
        </button>
      </div>
    </div>
    @if (state === SignOnWarningState.Success) {
      <div class="success-block">
        <i class="fa fa-check" aria-hidden="true"></i>
        <span>{{'Attempt to Sign On started' | translate}}</span>
      </div>
    }
    @if (state === SignOnWarningState.Error) {
      <div class="error-block">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <span>{{'Something went wrong' | translate}}: {{errorMessage | translate}}</span>
      </div>
    }
  </div>
}